import { useEffect, useMemo, useRef, useState } from 'react';
import '../../App.css'
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import {
  Box,
  Button,
  createTheme,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItemIcon,
  MenuItem,
  Tooltip,
  useTheme,
} from '@mui/material';
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ITaskType, ITaskDetails } from '../../interface/IOrders_Tasks';
import { useSelector } from 'react-redux';
import { IUser } from '../../interface/IUser';
import { AxiosInstance } from '../../api/apiInstance';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import { ITaskStatus, } from '../../interface/ITask';
//import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import TaskCreateDialog from './taskCreateDialog';
import TaskEditDialog from './taskEditDialog';
import { v4 as uuid } from 'uuid';
import PersonIcon from '@mui/icons-material/Person';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
//import { AccountCircle } from '@mui/icons-material';
import ProductsItemHierarchyDialog from '../productItems/ProductsItemHierarchyDialog';
import { muiTableBodyCellPropsHelper, muiTableHeadCellPropsHelper, taskTypeColor } from '../../helper/helper';
import ExtensionIcon from '@mui/icons-material/Extension';
import { IproductHierarchy, IproductLocation } from '../../interface/IProducts';
import UsersDialog from '../orders/usersDialog';
const Tasks = () => {
  const singleTaskPartNumber = useRef('');

  const hiddenColumns = {
    id: false,
    orderName: false,
    QTYtoassemble: false,
    QTYassembled: false,
    taskDetails: false,
    BIN: false,
    QTY: false,
    BIN_1: false,
    QTY_1: false,
    BIN_2: false,
    QTY_2: false,
    Supplier: false,
    PalletNumber: false,
    PO: false,
    taskInfo: false,
    NoOfBoxes: false,
    NoOfItems: false,
    bulkQauntity: false,

    trackingNumber: false,
    pictureOne: false,
    pictureTwo: false,
    status: false,
    customerName: false,
    cylinder: false,
    Location: false,
    statusRma: false,
    Total: false,
    backToInventory: false
  }
  const userRoleName = useRef('Packer');
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const userinfo: IUser = useSelector((state: any) => state.user)
  const taskStatus: ITaskStatus[] = useSelector((state: any) => state.taskStatus)
  const taskType: ITaskType[] = useSelector((state: any) => state.taskType)
  const TaskUsers: IUser[] = useSelector((state: any) => state.allUsers)
  const [singleTaskEdit, setSingleTaskEdit] = useState<ITaskDetails>();
  const [singleTaskCreate, setSingleTaskCreate] = useState<ITaskDetails>();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [disableSaveButton, setDisableSaveButton] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [partDialogDataLocation, setPartDialogDataLocation] = useState<IproductLocation[]>([]);
  const [partDialogDataHierarchy, setPartDialogDataHierarchy] = useState<IproductHierarchy[]>([]);
  const [openUsers, setOpenUsers] = useState(false);
  const [usersRowId, setUsersRowId] = useState('');


  const GetPartHierarchyData = async (id: string) => {
    try {
      await AxiosInstance({
        // url of the api endpoint (can be changed)
        url: "priorityProducts/findChildByParentPart/" + id,
        method: "GET",
      }).then((res) => {
        const dt = res.data as IproductHierarchy[];
        setPartDialogDataHierarchy(dt);

      });
    } catch (e) {

    }
  }

  const handleClose = () => {
    setOpen(false);
  }


  const handleOpenReassignUser = async (row: any) => {
    // const setUser =
    // {
    //   user: { id: 1 }
    // }
    // await AxiosInstance.patch('order/updateData/' + row.id, setUser)
    //   .then(function (response) {
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
    // refetch();    
    setUsersRowId(row.id);
    setOpenUsers(true);

  }

  const _handleReassignUser = async (rowId: any, user: any) => {
    const setUser =
    {
      user: { id: user }
    }
    await AxiosInstance.patch('task-user/' + rowId, setUser)
      .then(function (response) {
      })
      .catch(function (error) {
        console.log(error);
      });
    refetch();
  }

  function setDialogEditSingleTask(ts: ITaskDetails) {
    setSingleTaskEdit(ts);

  }
  function setDialogCreateSingleTask(ts: ITaskDetails) {
    const tmpTs = { ...ts };
    tmpTs.statusRma = 0;
    setSingleTaskCreate(tmpTs);

  }

  const [taskTypeFiltered, settaskTypeFiltered] = useState(taskType);

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const _handlePriority = async (row: any) => {
    //alert(JSON.stringify( row._valuesCache['taskType.role']))
    const setPriority =
    {
      taskPriority: 100
    }
    //task-user/E38FB95A-D2EE-EF11-9F80-5CC5D4460392
    await AxiosInstance.patch('task-user/' + row.id, setPriority)
      .then(function (response) {

      })
      .catch(function (error) {
        console.log(error);
      });
    refetch();
  }
  useEffect(() => {

    userRoleName.current = userinfo.userRoleName;

    if (userinfo.userRoleName === 'Administrator') {
      setIsAdmin(true);
    }
    else {
      setIsAdmin(false);
      const fltr = taskType.filter(g => {
        if (g.role === "Inventory count") return true;
        else return false;
      }
      )
      settaskTypeFiltered(fltr);
    }
    refetch();
  }, [userinfo.userRoleName])




  function getTaskTypeColor(userName: string) {
    const res = taskTypeColor.filter((c) => {
      if (c.name === userName)
        return true;
      return false;
    })
    if (res.length > 0)
      return res[0].color
    return 'grey'
  }
  function getUserColor(userName: string) {
    const res = TaskUsers.filter((usr) => {
      if (usr.userName === userName)
        return true;
      return false;
    })
    if (res.length > 0)
      return res[0].color
    return 'grey'
  }
  function getStatsColor(statusName: string) {
    const res = taskStatus.filter((tsk) => {
      if (tsk.status === statusName)
        return true;
      return false;
    })
    if (res.length > 0)
      return res[0].color
    return 'grey'
  }

  const columns = useMemo<MRT_ColumnDef<ITaskDetails>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'id',
        Edit: () => null,
      },
      {
        accessorKey: 'taskType.role',
        header: 'task Type',
        size: 80, //small column        
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor: getTaskTypeColor(cell.getValue<string>()),
              borderRadius: '0.25rem',
              color: 'black',

              //Width: '90%',
              p: '0.5rem',
            })}
          >
            {cell.getValue<string>()}
          </Box>
        ),

      },
      // {
      //   accessorKey: 'taskType.role',
      //   header: 'task Type',
      //   size: 80, //small column
      //   muiTableHeadCellProps: {}, //custom props
      //   //editVariant: 'select',
      //   //editSelectOptions: taskTypeFiltered.map(task => task.role),
      //   muiEditTextFieldProps: {
      //     required: true,
      //     error: !!validationErrors?.taskType,
      //     helperText: validationErrors?.taskType,
      //     //remove any previous validation errors when task focuses on the input
      //     onFocus: () =>
      //       setValidationErrors({
      //         ...validationErrors,
      //         taskRemarks: undefined,
      //       }),
      //     //optionally add validation checking for onBlur or onChange
      //   },
      // },
      {
        accessorKey: 'DataInfo',
        header: 'Title',
        size: 60, //small column
      },
      {
        accessorKey: 'Location',
        header: 'Location',
        size: 60, //small column
      },
      {
        accessorKey: 'PartNumber',
        header: 'Part Number',
        size: 80, //small column
        enableEditing: userinfo.userRoleName === "Administrator" ? true : false,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.PartNumber,
          helperText: validationErrors?.PartNumber,
          //remove any previous validation errors when task focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              taskInfo: undefined,
            }),
        },
      },
      {
        accessorKey: 'QTYtoassemble',
        header: 'QTYtoassemble',
        enableHiding: true,
        enableEditing: userinfo.userRoleName === "Administrator" ? true : false,

      },
      {
        accessorKey: 'QTYassembled',
        header: 'QTYassembled',
        enableHiding: true,

      },
      {
        accessorKey: 'backToInventory',
        header: 'backToInventory',
        enableHiding: true,

      },
      {
        accessorKey: 'createdAt',
        header: 'created At',
        size: 60, //small column
        enableEditing: false,
        Cell: ({ cell }) => (
          <Box
          >
            {cell?.getValue<string>()?.substring(0, 10)}
          </Box>
        ),
      },
      {
        accessorKey: 'Total',
        header: 'Total',
        size: 60, //small column
        enableHiding: true,
      },



      {
        accessorKey: 'BIN',
        header: 'BIN',
        enableHiding: true,
        size: 60, //small column
      },
      {
        accessorKey: 'QTY',
        header: 'QTY',
        enableHiding: true,

      },
      {
        accessorKey: 'BIN_1',
        header: 'BIN_1',
        enableHiding: true,
      },
      {
        accessorKey: 'QTY_1',
        header: 'QTY_1',
        enableHiding: true,
      },
      {
        accessorKey: 'BIN_2',
        header: 'BIN_2',
        enableHiding: true,
      },
      {
        accessorKey: 'QTY_2',
        header: 'QTY_2',
        enableHiding: true,
      },
      {
        accessorKey: 'Supplier',
        header: 'Supplier',
        enableHiding: true,
      },
      {
        accessorKey: 'PalletNumber',
        header: 'PalletNumber',
        enableHiding: true,
      },
      {
        accessorKey: 'PO',
        header: 'PO',
        enableHiding: true,
      },
      {
        accessorKey: 'NoOfBoxes',
        header: 'NoOfBoxes',
        enableHiding: true,
      },
      {
        accessorKey: 'NoOfItems',
        header: 'NoOfItems',
        enableHiding: true,
      },
      //****************************** */
      {
        accessorKey: 'rmaNumber',
        header: 'RMA No',
        enableHiding: true,
        size: 80, //small column
      },
      {
        accessorKey: 'trackingNumber',
        header: 'trackingNumber',
        enableHiding: true,
      },
      {
        accessorKey: 'pictureOne',
        header: 'pictureOne',
        enableHiding: true,
      },
      {
        accessorKey: 'pictureTwo',
        header: 'pictureTwo',
        enableHiding: true,
      },
      {
        accessorKey: 'statusRma',
        header: 'statusRma',
        enableHiding: true,
      },
      {
        accessorKey: 'customerName',
        header: 'NoOfItems',
        customerName: true,
      },
      //******************************** */    
      {
        accessorKey: 'bulkQauntity',
        header: 'bulkQauntity',
        enableHiding: true,
      },
      {
        accessorKey: 'cylinder',
        header: 'cylinder',
        enableHiding: true,
      },
      {
        accessorKey: 'user.userName',
        header: 'user',
        size: 80, //small column
        editVariant: userinfo.userRoleName === 'Administrator' ? 'select' : 'text',
        editSelectOptions: userinfo.userRoleName === 'Administrator' ?
          TaskUsers.map(user => user.userName) :
          undefined,
        muiEditTextFieldProps: {
          select: true,
          error: !!validationErrors?.userName,
          helperText: validationErrors?.userName,
        },
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor: getUserColor(cell.getValue<string>()),
              borderRadius: '0.25rem',
              color: 'black',

              //Width: '90%',
              p: '0.5rem',
            })}
          >
            {cell.getValue<string>()}
          </Box>
        ),

      },
      {
        accessorFn: (row) => `${row.taskStatus.status}`, //alternate way
        id: "taskStatus", //id required if you use accessorFn instead of accessorKey
        header: "Status",
        size: 80, //small column
        Header: <i>task Status</i>, //optional custom markup
        editVariant: 'select',
        editSelectOptions: taskStatus.map(state => state.status),
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor: getStatsColor(cell.getValue<string>()),
              borderRadius: '0.25rem',
              color: 'black',
              //Width: '90%',
              p: '0.5rem',
            })}
          >
            {cell.getValue<string>()}
          </Box>
        ),
      },



      {
        accessorKey: 'orderName',
        header: 'Order',
        size: 80, //small column
        enableEditing: false,
        Edit: () => null,
      },
    ],
    [validationErrors],
  );

  //call CREATE hook
  const { mutateAsync: createTask, isPending: isCreatingTask } =
    useCreateTask();
  //call READ hook
  const {
    data: fetchedTasks = [],
    isError: isLoadingTasksError,
    isFetching: isFetchingTasks,
    isLoading: isLoadingTasks,
    refetch,
  } = useGetTasks();
  //call UPDATE hook
  const { mutateAsync: updateTask, isPending: isUpdatingTask } =
    useUpdateTask();


  function useUpdateTask() {
    const queryClient = useQueryClient();
    const tmpEdit = { ...singleTaskEdit }
    return useMutation({
      mutationFn: async (taskDetails: any) => {
        if (singleTaskEdit === undefined) return;
        if (singleTaskEdit?.user.id === 1 || singleTaskEdit?.user.id === 1000) //unasgined or global user
        {
          tmpEdit.user = TaskUsers.find((t) => { if (t.id === userinfo.id) return true; });

        }
        tmpEdit.BIN = String(tmpEdit.BIN);
        await AxiosInstance.patch('task-user/' + singleTaskEdit.id, tmpEdit)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      //client side optimistic update
      onMutate: (newTaskDetailsInfo: any) => {
        if (singleTaskEdit === undefined) return;
        queryClient.setQueryData(['taskDetails'], (prevTasks: any) =>
          prevTasks?.map((prevTask: ITaskDetails) =>
            prevTask.id === singleTaskEdit?.id ? singleTaskEdit : prevTask,
          ),
        );
      },
      onSettled: () => queryClient.invalidateQueries({ queryKey: ['taskDetails'] }), //refetch tasks after mutation, disabled for demo
    });
  }

  //call DELETE hook
  const { mutateAsync: deleteTask, isPending: isDeletingTask } =
    useDeleteTask();

  //CREATE action
  const handleCreateTask: MRT_TableOptions<ITaskDetails>['onCreatingRowSave'] = async ({
    values,
    table,
  }) => {
    // const newValidationErrors = validateTask(singleTaskEdit);
    // if (Object.values(newValidationErrors).some((error) => error)) {
    //   setValidationErrors(newValidationErrors);
    //   return;
    // }
    setValidationErrors({});
    await createTask(values);
    table.setCreatingRow(null); //exit creating mode
  };

  //UPDATE action
  //const handleSaveTask: MRT_TableOptions<TaskDetails>['onEditingRowSave'] = async ({



  const handleSaveTask = async (
    // row,
    // values,
    // table
  ) => {
    if (singleTaskEdit?.PartNumber.length === 0 && (
      singleTaskEdit.taskType.id !== 4)) {
      window.alert('Part Number Not Set')
      return;
    }
    if (singleTaskEdit?.taskType.id === 1001) {
      if (singleTaskEdit?.rmaNumber === null || singleTaskEdit?.rmaNumber === '') {
        window.alert('RMA Number Not Set')
        return;
      }
      if (singleTaskEdit?.customerName === null) {
        window.alert('customer Name Not Set')
        return;
      }
      if (singleTaskEdit?.QTY === 0) {
        window.alert('Qunatity Not Set')
        return;
      }


    }


    if (singleTaskPartNumber.current !== singleTaskEdit?.PartNumber) {
      if (!window.confirm('Part Number Changed, Do you wish to continue ?')) {
        return;
      }
    }
    if (singleTaskEdit !== undefined
      && singleTaskEdit.taskStatus.id === 5
      && +singleTaskEdit.Total === 0
      && (singleTaskEdit.taskType.id === 1 || singleTaskEdit.taskType.id === 5)
    ) {
      //setValidationErrors(newValidationErrors);
      window.alert('QTYassembled must not equal 0');
      return;
    }
    if (singleTaskEdit !== undefined
      && singleTaskEdit.taskStatus.id === 5
      && +singleTaskEdit.Total !== singleTaskEdit.QTYtoassemble
      && (singleTaskEdit.taskType.id === 1 ||
        singleTaskEdit.taskType.id === 5 ||
        singleTaskEdit.taskType.id === 1001)
    ) {
      //setValidationErrors(newValidationErrors);
      window.alert('QTY assembled not equals QTY to assemble!!!');
      return;
    }

    setValidationErrors({});

    await updateTask(singleTaskEdit);
    table.setEditingRow(null); //exit editing mode

  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<ITaskDetails>) => {
    if (window.confirm('Are you sure you want to delete this task?')) {
      deleteTask(row.original.id);
    }
  };
  //const [draggingRow, setDraggingRow] = useState<MRT_Row<TaskDetails> | null>(null);

  //READ hook (get tasks from api)
  function useGetTasks() {
    return useQuery<ITaskDetails[]>({
      queryKey: ['taskDetails'],
      queryFn: async () => {
        //send api request here            
        return await AxiosInstance({
          // url of the api endpoint (can be changed)
          url: "task-user",
          method: "GET",
        }).then((res) => {
          // handle success
          const AllData = res.data as ITaskDetails[];
          const tmpTaskData = AllData.filter((dt) => {

            if (userRoleName.current === 'Administrator') {

              return true;
            }
            else {
              if (dt.user.id === userinfo.id || dt.user.id === 1000 || dt.user.id === 1) { //1000 global
                return true;
              }
              else {
                return false;
              }
            }
          })
          return tmpTaskData as ITaskDetails[];
        });
      },
      refetchOnWindowFocus: 'always',
    });
  }
  async function SaveAndContinue() {

    const tmpCreate = { ...singleTaskEdit }
    if (singleTaskEdit?.PartNumber.length === 0 && (
      singleTaskEdit.taskType.id !== 4 && singleTaskEdit.taskType.id !== 1001)) {
      window.alert('Part Number Not Set')
      return;
    }

    if (singleTaskEdit?.taskType.id === 1001) {
      const taskExists = fetchedTasks.find((ts) => {
        if (ts.rmaNumber === singleTaskEdit?.rmaNumber && ts.PartNumber === singleTaskEdit?.PartNumber) return true;
        return false;
      })
      if (taskExists !== undefined) {
        const alertMessage = 'RMA number and Part number already exists, Are you sure you want to Continue ?';
        if (!window.confirm(alertMessage)) {
          return;
        }
      }
    }
    else {
      const taskExists = fetchedTasks.find((ts) => {
        if (ts.DataInfo === singleTaskEdit?.DataInfo && ts.PartNumber === singleTaskEdit?.PartNumber) return true;
        return false;
      })
      if (taskExists !== undefined) {
        const alertMessage = 'Title and Part number already exists, Are you sure you want to Continue ?';
        if (!window.confirm(alertMessage)) {
          return;
        }
      }
    }



    if (singleTaskEdit?.user.id === 1 || singleTaskEdit?.user.id === 1000) //unasgined or global user
    {
      //alert(singleTaskEdit?.user.id + ' - ' + userinfo.id)
      tmpCreate.user = TaskUsers.find((t) => { if (t.id === userinfo.id) return true; });

    }
    const newInvCount = JSON.parse(JSON.stringify(tmpCreate));
    newInvCount.id = uuid();
    //if(singleTaskEdit?.taskType.id !== 1001){    
    await AxiosInstance.post('/task-user', newInvCount)
      .then(function (response) {

      })
      .catch(function (error) {
        console.log(error);
      });
    await sleep(50)
    clearInfo()
    await sleep(50)
    setDisableSaveButton(true);
    refetch();

  }
  function clearInfo() {
    const ClrsingleTaskEdit = { ...singleTaskEdit } as ITaskDetails;

    ClrsingleTaskEdit.BIN = '0';
    ClrsingleTaskEdit.BIN_1 = '0';
    ClrsingleTaskEdit.BIN_2 = '0';
    ClrsingleTaskEdit.QTY = 0;
    ClrsingleTaskEdit.QTY_1 = 0;
    ClrsingleTaskEdit.QTY_2 = 0;
    ClrsingleTaskEdit.NoOfBoxes = 0;
    ClrsingleTaskEdit.NoOfItems = 0;
    ClrsingleTaskEdit.Total = 0;
    ClrsingleTaskEdit.PartNumber = '';
    ClrsingleTaskEdit.bulkQauntity = 0;
    ClrsingleTaskEdit.pictureOne = '';
    ClrsingleTaskEdit.pictureTwo = '';
    setSingleTaskEdit(ClrsingleTaskEdit);

  }
  //CREATE hook (post new task to api)
  function useCreateTask() {

    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async (taskDetails: any) => {
        await AxiosInstance.post('/task-user', singleTaskCreate)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      //client side optimistic update
      onMutate: (newTaskDetailsInfo: any) => {
        queryClient.setQueryData(
          ['taskDetails'],
          (prevTasks: any) =>
            [
              ...prevTasks,
              {
                ...singleTaskCreate,
              },
            ] as ITaskDetails[],
        );
      },
      onSettled: () => queryClient.invalidateQueries({ queryKey: ['taskDetails'] }), //refetch tasks after mutation, disabled for demo
    });
  }
  //UPDATE hook (put task in api)

  const table = useMaterialReactTable({
    //enableRowOrdering: isAdmin,
    autoResetPageIndex: false,
    columns,
    enableColumnActions: false,
    enablePagination: true,
    enableBottomToolbar: true,
    enableColumnFilterModes: false,
    enableSorting: true,
    enableHiding: false,
    enableDensityToggle: false,
    enableColumnFilters: false,
    data: fetchedTasks,
    enableRowActions: true,
    enableFullScreenToggle: false,
    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: isAdmin,
    enableRowOrdering: false,
    initialState: { columnVisibility: hiddenColumns, density: 'compact', pagination: { pageSize: 50, pageIndex: 0 }, },
    getRowId: (row) => row.id,
    enableRowDragging: false,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        setDisableSaveButton(false);
        const singleTask = fetchedTasks.find(ts => {
          if (ts.id === row.id) return true; return false;
        });
        setSingleTaskEdit(singleTask)
        singleTaskPartNumber.current = singleTask?.PartNumber ?? '';
        table.setEditingRow(row);

      },
      sx: {
        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
      },
    }),
    //onDraggingRowChange: setDraggingRow,


    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
        //padding: '1rem',
        margin: '1rem',
      },
    },
    muiTableBodyProps: {
      sx: {
        //stripe the rows, make odd rows a darker color
        '& tr:nth-of-type(odd) > td': {
          backgroundColor: '#f5f5f5',
        },
      },
    },
    muiTableHeadCellProps: {
      //no useTheme hook needed, just use the `sx` prop with the theme callback
      sx: (theme) => (muiTableHeadCellPropsHelper),
    },
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        muiTableBodyCellPropsHelper
      },
    }),

    muiToolbarAlertBannerProps: isLoadingTasksError
      ? {
        color: 'error',
        children: 'Error loading data',
      }
      : undefined,

    onCreatingRowCancel: () => {
      setValidationErrors({});
      setDisableSaveButton(false);
    },
    onCreatingRowSave: handleCreateTask,
    onEditingRowCancel: () => {
      setValidationErrors({});
      setDisableSaveButton(false);
    },
    //onEditingRowSave: handleSaveTask,
    //optionally customize modal content
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>

        <DialogTitle sx={{ color: 'red' }}
          variant="h5">Create New Task</DialogTitle>
        <DialogContent
          sx={{
            display: 'flex', flexDirection: 'column', gap: '1rem'
          }}

        >
          {/* {retinternalEditComponentsCreate(internalEditComponents, row)} */}

          <TaskCreateDialog setDialogCreateSingleTask={setDialogCreateSingleTask} />
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h5" >Edit {row._valuesCache['taskType.role']}  </DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}

        >
          {/* {retinternalEditComponentsEdit(internalEditComponents, row)} */}
          <TaskEditDialog setDialogEditSingleTask={setDialogEditSingleTask} rowData={singleTaskEdit
            // fetchedTasks.find(ts => {
            // if (ts.id === row.id) return true; return false;
            // })
          } />
        </DialogContent>
        <DialogActions>
          {/* <MRT_EditActionButtons variant="text" table={table} row={row}/> */}
          <Button variant="contained" color="warning" onClick={() => {
            setValidationErrors({});
            setDisableSaveButton(false);
            table.setEditingRow(null); //exit editing mode
          }} >
            Cancel
          </Button>
          <Button variant="contained" color="info" disabled={disableSaveButton}
            onClick={() => {

              handleSaveTask(); //row, row._valuesCache, table
            }} >
            Save
          </Button>

          {fetchedTasks.find(ts => {
            if (ts.id === row.id) return true; return false;
          })?.taskType.id === 2 ?  //inventory count
            <Button variant="contained" color="success" onClick={() => { SaveAndContinue() }} >
              Save as new line </Button>
            : fetchedTasks.find(ts => {
              if (ts.id === row.id) return true; return false;
            })?.taskType.id === 3 ?  //inventory count
              <Button variant="contained" color="success" onClick={() => { SaveAndContinue() }} >
                Save as new line </Button>
              : fetchedTasks.find(ts => {
                if (ts.id === row.id) return true; return false;
              })?.taskType.id === 6 ?  //inventory count
                <Button variant="contained" color="success" onClick={() => { SaveAndContinue() }} >
                  Save as new line </Button>
                : fetchedTasks.find(ts => {
                  if (ts.id === row.id) return true; return false;
                })?.taskType.id === 1001 ?  //rma
                  <Button variant="contained" color="success" onClick={() => { SaveAndContinue() }} >
                    Save as new line </Button>


                  : <></>
          }
        </DialogActions>
      </>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', textAlign: 'center' }}>
        {isAdmin ?
          <>
            <Tooltip title="Delete">
              <IconButton color="error" onClick={(event) => {
                event.stopPropagation();
                openDeleteConfirmModal(row);
              }}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="urgent">
              <IconButton color="success" onClick={(event) => {
                event.stopPropagation();
                _handlePriority(row);
              }}>
                <PriorityHighIcon style={{ color: 'orange' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="UnAssign User" >
              <IconButton color="success" onClick={(event) => {
                event.stopPropagation();
                handleOpenReassignUser(row);
              }}>
                <PersonIcon style={{ color: '#6495ED' }} />
              </IconButton>
            </Tooltip>
          </> : <></>}
        {/* {row._valuesCache['taskType.role'] === 'Assembly' ? */}
        {/* {fetchedTasks[row.index].taskType.role === 'Assembly' ?

          <Tooltip title="hierarchy">
            <IconButton color="success" onClick={(event) => {
              event.stopPropagation();
              GetPartHierarchyData(row._valuesCache['PartNumber']);
              setOpen(true);
            }}>
              <ExtensionIcon style={{ color: 'black' }} />
            </IconButton>
          </Tooltip>
          : <></>}
          */}
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <div>
        {/* <Button
        variant="contained"
        onClick={() => {
          table.setCreatingRow(true); //simplest way to open the create row modal with no default values       
        }}
      >
        Create New Task 
      </Button> */}
        {/* {userinfo.userRoleName === 'Administrator' ? */}
        <Tooltip arrow title="add Task">
          <IconButton onClick={() => table.setCreatingRow(true)}>
            <AddIcon />
          </IconButton>
        </Tooltip>
        {/* : <></>
        } */}
        <Tooltip arrow title="Refresh Data">
          <IconButton size="large" onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </div>
    ),

    state: {
      isLoading: isLoadingTasks,
      isSaving: isCreatingTask || isUpdatingTask || isDeletingTask,
      showAlertBanner: isLoadingTasksError,
      showProgressBars: isFetchingTasks,
    },
  });

  return <>
    <UsersDialog
      open={openUsers}
      rowId={usersRowId}

      handleReassignUser={_handleReassignUser}
      onClose={setOpenUsers}
    ></UsersDialog>
    <ProductsItemHierarchyDialog
      selectedValueLocation={partDialogDataLocation}
      selectedValueHierarchy={partDialogDataHierarchy}
      open={open}
      onClose={handleClose}
      dialogTitle={'Part Hierarchy'}

    />
    <MaterialReactTable table={table} />
  </>;
};







//DELETE hook (delete task in api)
function useDeleteTask() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (taskDetailsId: string) => {
      AxiosInstance.delete('task-user/' + taskDetailsId) // movie = ID of the movie entry in mySQL
        .then(res => {
        })
        .catch(err => { console.log(err) })
    },
    //send api update request here
    // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
    // return Promise.resolve();

    //client side optimistic update
    onMutate: (taskDetailsId: string) => {
      queryClient.setQueryData(['taskDetails'], (prevTasks: any) =>
        prevTasks?.filter((taskDetails: ITaskDetails) => taskDetails.id !== taskDetailsId),
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['tasks'] }), //refetch tasks after mutation, disabled for demo
  });
}

const queryClient = new QueryClient();

const ExampleWithProviders = () => (
  //Put this with your other react-query providers near root of your app
  <QueryClientProvider client={queryClient}>
    <Tasks />
  </QueryClientProvider>
);

export default ExampleWithProviders;

const validateRequired = (value: string) => !!value.length;

const validateNumber = (value: number, status: string) =>
  value === 0 && status === 'Complete';

const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

function validateTask(taskDetails: any) {
  console.log(taskDetails)
  return {
    PartNumber: validateRequired(taskDetails.PalletNumber)
    //   ? 'QTYassembled must not equal 0'
    //   : '',

  };
}
